import get from 'lodash/get';
import map from 'lodash/map';

export const generateInitialEditpaylod = (offering) => {
  const step1 = get(offering, 'SalesChannel');
  const step2 = map(get(offering, 'OfferingProducts'), (prod) => ({
    ...get(prod, 'Product'),
    quantity: get(prod, 'item_count'),
  }));

  const step3 = {
    name: get(offering, 'name'),
    mrp: get(offering, 'mrp'),
    item_count: get(offering, 'item_count'),
    discount_percent: get(offering, 'discount_percent'),
    availability: get(offering, 'availability'),
    partner_retailer: map(
      get(offering, 'OfferingPartnerRetailers'),
      'partner_retailer_id'
    ),
  };

  const step4 = {
    other_info: get(offering, 'other_info'),
  };

  return {
    step: 0,
    step1,
    step2,
    step3,
    step4,
  };
};

export const b = 1;
